import axios, { AxiosRequestConfig, Method } from "axios";
import type { AxiosInstance } from 'axios'
import { h, VNode } from "vue";
import type { RendererElement, RendererNode } from "vue";
import useStore from "@/config/pinia";
import { getLocalData, getAsyncReader } from "@utils";
import { errorHandler } from "@/errorHandler/handle";
export type TResult<T = any> = Promise<{
  [x: string]: any;
  message(message: any): unknown;
  trace_id: string;
  filename(data: any, filename: any): unknown;
  data: T;
  code: number | string;
  count?: number;
  msg: string;
}>;

let showError = false; //是否提示
const notificationMessage = (message: string) => {
  if (showError) {
    return;
  }
  if (typeof message == "function") {
    window.$notification["error"]({
      content: "错误提示",
      meta: () => {
        return message();
      },
      duration: 3000,
    });
  } else {
    window.$notification["error"]({
      content: "错误提示",
      meta: message,
      duration: 3000,
    });
  }
  showError = true;
  let tipsSetTime = setTimeout(() => {
    showError = false;
    clearTimeout(tipsSetTime);
  }, 500);
};

const request: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_HOST as string,
  headers: { "Content-Type": "application/json" },
  withCredentials: false,
  // timeout: 300000, //上传超时限制
  timeout: 2 * 60 * 60 * 1000, //上传超时限制
});

request.interceptors.request.use(
  (config) => config,
  (error) => {
    return Promise.reject(error);
  }
);
function parseContentDisposition(
  disposition: string | undefined
): Record<string, string> {
  const keyValuePairs = (disposition && disposition.split(";")) || [];
  const result: Record<string, string> = {};

  keyValuePairs.forEach((keyValue) => {
    const [key, value] = keyValue
      .trim()
      .split("=")
      .map((part) => part.trim().replace(/"/g, ""));
    if (key && value) {
      result[key] = decodeURIComponent(value);
    }
  });

  return result;
}
const errorMessageTips = (res: any) => {
  let resultList: VNode<
    RendererNode,
    RendererElement,
    { [key: string]: any }
  >[] = [];
  let messageList: any = [];
  window.$notification["error"]({
    content: res.data.message,
    meta: () => {
      res.data.data.forEach((item) => {
        item.err_message.forEach((mes) => {
          messageList.push(
            h(
              "div",
              {
                className: "error-msg-content",
              },
              {
                default: () => `${mes}`,
              }
            )
          );
        });
        resultList.push(
          h(
            "div",
            {
              className: "error-msg",
            },
            {
              default: () => [
                h(
                  "p",
                  {
                    className: "error-title",
                  },
                  {
                    default: () => `${item.field}`,
                  }
                ),
                ...messageList,
              ],
            }
          )
        );
      });
      return resultList;
    },
  });
}
// 非阻断长显提示
const warningMessageTips = (res: any) => {
  window.$notification["warning"]({
    content: "提示",
    meta: res.data.message,
    duration: 0,
  });
}
const resJsonRespoones = (code: any, message: any, res: any, store: any) => {
  if (code) {
    switch (Number(code)) {
      case 200: {
        return res.data;
      }
      case 4010: {
        // 登录过期
        if (!store.isRemove) {
          window.location.href = "/#/login";
          store.loginOut();
        }
        // notificationMessage(
        //   "由于您长时间未登录，为了保证数据安全，系统已自动退出，请重新登录!"
        // );
        window.$message.error("您的token已失效，系统已自动退出，请重新登录!");

        return Promise.reject(res.data);
      }
      case 4020: {
        // 权限变更
        let messageH = () => {
          return h(
            "span",
            { style: "word-wrap:break-word" },
            { default: () => message || "服务器错误" }
          );
        };
        notificationMessage(messageH);
        return Promise.reject(res.data);
      }
      case 4100: {
        errorMessageTips(res);
        return res.data;
      }
      case 4200: {
        errorMessageTips(res);
        return res.data;
      }
      case 4003: {
        return Promise.reject(res.data);
      }
      case 4040: {
        if (!store.isRemove) {
          window.location.href = "/#/login";
          store.loginOut();
        }
        // );
        window.$message.error("登录过期，请重新登录");

        return Promise.reject(res.data);
      }
      case 4060: {
        warningMessageTips(res);
        return res;
      }
      default:
        let messageH = () => {
          return h(
            "span",
            { style: "word-wrap:break-word" },
            { default: () => message || "服务器错误" }
          );
        };
        notificationMessage(messageH);
        return Promise.reject(res.data);
    }
  }
  if (res.data instanceof Blob) {
    //可以拿到用户名
    return res;
  } else {
    return res.data;
  }
}


request.interceptors.response.use(
  async (res: any) => {
    const store = useStore();
    //如果默认响应是blob类型，但是返回的是json格式数据，则需要手动转译一下
    if (res.headers['content-type'].includes('application/json')) {
      if (res.config.responseType == 'blob') {
        let reader: any = new FileReader()
        await reader.readAsText(res.data, 'utf-8')
        return getAsyncReader(reader).then(async () => {
          res.data = JSON.parse(reader.result)
          // 处理相关逻辑...
          const { code, message } = res.data || {};
          if (Number(code) === 4020) {
            // 权限变更，刷新用户信息和菜单
            await store.refreshUserInfo();
            store.updateMenu();
          }
          return resJsonRespoones(code, message, res, store)
        });
      } else {
        const { code, message } = res.data || {};
        if (Number(code) === 4020) {
          // 权限变更，刷新用户信息和菜单
          await store.refreshUserInfo();
          store.updateMenu();
        }
        return resJsonRespoones(code, message, res, store)
      }
    } else if (res.headers['content-type'].includes('multipart/form-data')) {
      const disposition = res.headers["content-disposition"];
      const dispositionObject = parseContentDisposition(disposition);
      if (Object.keys(dispositionObject).length > 0) {
        dispositionObject.data = res.data;
        return dispositionObject;
      }
    } else {
      const { code, message } = res.data || {};
      if (Number(code) === 4020) {
        // 权限变更，刷新用户信息和菜单
        await store.refreshUserInfo();
        store.updateMenu();
      }
      return resJsonRespoones(code, message, res, store)
    }
  },
  (err) => {
    switch (err?.response?.status) {
      case 4010: {
        notificationMessage(
          "由于您长时间未登录，为了保证数据安全，系统已自动退出，请重新登录!"
        );
        break;
      }
      default:
        {
          let spError = errorHandler.getErrorCode(err.stack);
          console.error(errorHandler, 123456)
          if (spError != undefined) {
            notificationMessage(spError.msg);
          } else {
            // notificationMessage("服务器错误");
          }
        }
        break;
    }
    return Promise.reject(err.response);
  }
);

interface RequestOptions extends Partial<AxiosRequestConfig> {
  isAuth?: boolean;
  isToken?: boolean;
  isBuff?: boolean;
  isStream?: boolean;
  urlFields?: string[];
  isForm?: boolean;
  transformParams?: (params: any) => any;
}

const createMethod =
  (method: Method = "get") =>
    (url: string, options?: RequestOptions, cbParms?: {
      uploadcb?: Function;
      downcb?: Function;
    }) => {
      const store = useStore();
      let {
        urlFields,
        isAuth = false,
        isToken = true,
        isForm = false,
        isBuff = false,
        isStream = false,
        headers = {},
        params,
        transformParams,
        cancelToken,
        ...args
      } = options || {};
      let responseType = "json";
      let data = ["get"].includes(method) ? { params } : { data: params };
      // 处理formdata形式
      if (isForm) {
        // 如果 params 已经是 FormData，直接使用
        if (params instanceof FormData) {
          data.data = params;
        } else {
          // 否则遍历创建 FormData
          const formParams = new FormData();
          for (const key in params) {
            formParams.append(key, params[key]);
          }
          data.data = formParams;
        }
        // 注意：不要手动设置 Content-Type，让浏览器自动设置（包含 boundary）
        // 手动设置会导致 boundary 丢失，触发 CORS 预检请求
        headers = Object.assign({}, options?.headers);
      }
      //接口增加权限token
      if (isToken) {
        const users = store.tokenData;
        if (users && users["access_token"]) {
          headers = Object.assign({}, options?.headers, {
            Authorization: `bearer ${getLocalData("token-data").access_token}`,
          });
        }
      }

      if (isAuth) {
        headers = Object.assign({}, options?.headers, {
          Authorization:
            "Basic YWRfb3BlcmF0aW9uX2lkOmJnZmQ5MDM1NjRwbG9tZ3Jldzgwamg1Njd5dXBsbw==",
        });
      }
      if (isBuff) {
        responseType = "blob";
      }
      if (isStream) {
        responseType = "stream";
      }
      if (typeof transformParams === "function") {
        data = transformParams(params);
      }
      // 过滤URl参数
      if (urlFields) {
        for (const key of urlFields) {
          url = url.replace(new RegExp(`:${key}`), (params as any)[key]);
        }
      }
      return request(url, {
        method,
        responseType,
        headers,
        ...data,
        ...args,
        onUploadProgress: (progressEvent: any) => {
          // console.error(222, progressEvent)
          if (progressEvent.lengthComputable) {
            const complete = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );
            cbParms && cbParms.uploadcb && cbParms.uploadcb(complete);
          }
        },
        onDownloadProgress: (progressEvent: any) => {
          // console.error(333, progressEvent)
          if (progressEvent.currentTarget) {
            const complete = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );
            // console.error(complete, '结果')
            if (cbParms) {
              const disposition = progressEvent.currentTarget.getResponseHeader(
                "Content-Disposition"
              );
              const dispositionObject = parseContentDisposition(disposition);
              cbParms &&
                cbParms.downcb &&
                cbParms.downcb(complete, dispositionObject);
            }
          }
        },
        cancelToken: cancelToken,
      } as any) as Promise<any> | any;
    };

export const Post = createMethod("post");
export const Get = createMethod("get");
export const Delete = createMethod("delete");
export const Put = createMethod("put");

export default request;
